module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"changePlan":"Изменение тарифного плана","subject":"Вы переходите на тарифный план «{plan}»","renewPlan":"Возобновление подписки"}}')
  delete Component.options._Ctor
}
